import { ReactNode } from "react";
import styles from "./LoadingPattern.module.scss";
import { CSSProperties } from "react";
import theme from "theme";
import { Box, SxProps, Theme } from "@mui/material";

export interface LoadingPatternProps {
  size?: number;
  centered?: boolean;
  sx?: SxProps<Theme>;
}

interface LoadingPatternWrapperProps {
  centered?: boolean;
  children?: ReactNode;
  sx: SxProps<Theme>;
}

const LoadingPatternWrapper = ({ centered, children, sx }: LoadingPatternWrapperProps) => {
  return centered === true ? (
    <Box sx={{ ...{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }, ...sx }}>
      {children}
    </Box>
  ) : (
    <>{children}</>
  );
};

const LoadingPattern = (props: LoadingPatternProps) => {
  const size = props.size || 80;

  const style = {
    "--uib-size": size + "px",
    "--uib-color": theme.palette.primary.main,
    "--uib-speed": 1 + "s",
    // No SxProps here as this is a CSS variable going into a div
  } as CSSProperties;

  return (
    <LoadingPatternWrapper centered={props.centered} sx={props.sx || {}}>
      <div className={styles.container} style={style}>
        <div className={styles.dot1} />
        <div className={styles.dot2} />
        <div className={styles.dot3} />
        <div className={styles.dot4} />
        <div className={styles.dot5} />
        <div className={styles.dot6} />
        <div className={styles.dot7} />
        <div className={styles.dot8} />
        <div className={styles.dot9} />
        <div className={styles.traveler} />
      </div>

      <svg width="0" height="0" className={styles.svg}>
        <defs>
          <filter id="uib-jelly-triangle-ooze">
            <feGaussianBlur in="SourceGraphic" stdDeviation={size / 12} result="blur" />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
              result="ooze"
            />
            <feBlend in="SourceGraphic" in2="ooze" />
          </filter>
        </defs>
      </svg>
    </LoadingPatternWrapper>
  );
};

export default LoadingPattern;
